import type { Locale } from "../../../../core/schema/Locale.js";
import { NamedError } from "../../../../core/utils/NamedError.js";
import { getExpectedError } from "../../../../core/utils/getExpectedError.js";
import { findExpectedAppSyncErrorMessage } from "../../appsync/findExpectedAppSyncErrorMessage.js";

export function expectErrorMessage(
	error: unknown,
	locale: Locale,
	expectedError: Record<string, string> = {},
	defaultMessage?: string,
): string | undefined {
	if (error instanceof NamedError || error instanceof Error) {
		if (error.name in expectedError) {
			return expectedError[error.name] ?? defaultMessage;
		}
	}

	const expectedFromSystem = getExpectedError(error, locale);
	if (expectedFromSystem) {
		return expectedFromSystem;
	}

	return findExpectedAppSyncErrorMessage(error, expectedError) ?? defaultMessage;
}
